import { render, staticRenderFns } from "./HealthRecordIcon.vue?vue&type=template&id=5da0bdf0"
import script from "./HealthRecordIcon.vue?vue&type=script&lang=js"
export * from "./HealthRecordIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports